<template>
  <v-layout>
    <v-flex>
      <v-toolbar class="elevation-1">
        <v-btn small dark color="light-blue darken-3" @click="add_dialog.show = true">
          Добавить сертификат
        </v-btn>
        <v-btn small @click="clearLocalStorage()">
          Очистить локальное хранилище ЭЦП
        </v-btn>
      </v-toolbar>
      <v-card>
        <v-card-title>
          <h3 class="title">Список сертификатов</h3>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="certificates"
          no-data-text="Сертификаты отсутствуют"
          hide-actions
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.serial }}</td>
            <td>{{ props.item.organization }}</td>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.title }}</td>
            <td>{{ props.item.edrpou }}</td>
            <td>{{ props.item.drfo }}</td>
            <td>{{ props.item.valid_to | date }}</td>
            <td>
              <v-tooltip bottom>
                <v-btn slot="activator" icon @click.stop="confirmDelete(props.item)" class="ma-0">
                  <v-icon small color="pink">
                    delete
                  </v-icon>
                </v-btn>
                <span>Удалить</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="add_dialog.show" persistent lazy max-width=500>
        <v-card>
          <v-card-title>
            <h3 class="title">Добавление нового сертификата</h3>
          </v-card-title>
          <v-card-text>
            <v-form ref="add_form">
              <v-text-field
                ref="pkey"
                v-model="add_dialog.form.pkey"
                @input="processFile($event)"
                :error-messages="pkeyErrors"
                label="Файл ЭЦП"
                type="file"></v-text-field>
              <v-select
                v-model="add_dialog.form.issuer"
                :items="cas"
                :error-messages="issuerErrors"
                label="АЦСК"
                item-text="issuerCN"
                return-object
                @blur="$v.add_dialog.form.issuer.$touch()"
                @input="$v.add_dialog.form.issuer.$touch()"
              ></v-select>
              <v-text-field
                v-model="add_dialog.form.password"
                :error-messages="passwordErrors"
                :rules="add_dialog.form.passwordRules"
                label="Пароль к ЭЦП" 
                type="password"
                @blur="$v.add_dialog.form.password.$touch()"
                @input="$v.add_dialog.form.password.$touch()"
              ></v-text-field>
              <v-checkbox
                label="Сохранить ЭЦП для быстрого доступа"
                color="light-blue darken-3"
                v-model="add_dialog.form.save_key"
              >
              </v-checkbox>
            </v-form>
            <v-alert
              :value="add_dialog.form.alert"
              type="error">
              {{ add_dialog.form.alert_error }}
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-btn flat @click.native="reset()">
              Сбросить
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn flat @click="closeDialog()">
              Отмена
            </v-btn>
            <v-btn @click="submit_add()" dark color="light-blue darken-3" :loading="add_dialog.form.loading">
              Добавить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      
      <template v-if="del_dialog.show">
        <v-dialog v-model="del_dialog.show" persistent lazy max-width="400">
          <v-card>
            <v-card-title class="title">Удалить сертификат</v-card-title>
            <v-card-text>
              <b>Организация:</b>&nbsp; {{ del_dialog.item.organization }}<br>
              <b>ФИО:</b>&nbsp; {{ del_dialog.item.name }}<br>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click.native="closeDialog()">Отмена</v-btn>
              <v-btn dark color="pink" @click.native="deleteItem()">Удалить</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapState } from 'vuex'
  import { readFileFromComputer, readPrivateKey, signFile, enumJKSPrivateKeys, getJKSPrivateKey } from '@/utils'
  import { validationMixin } from 'vuelidate'
  import { required } from 'vuelidate/lib/validators'
  import moment from 'moment'


  export default {
    name: 'DocumentSignDialog',
    mixins: [validationMixin],
    validations: {
      add_dialog: {
        form: {
          pkey: { required },
          issuer: { required },
          password: { required }
        }
      }
    },
    data () {
      return {
        del_dialog: {
          show: false,
          item: null
        },
        add_dialog: {
          show: false,
          form: {
            alert: false,
            alert_error: '',
            loading: false,
            pkey: null,
            issuer: null,
            password: '',
            save_key: false,
            file: null
          }
        },
        headers: [
          {
            text: 'Серийный номер',
            value: 'serial',
            sortable: false
          },
          {
            text: 'Организация',
            value: 'organization',
            sortable: false
          },
          {
            text: 'ФИО',
            value: 'name',
            sortable: false
          },
          {
            text: 'Должность',
            value: 'title',
            sortable: false
          },
          {
            text: 'ЕДРПОУ',
            value: 'edrpou',
            sortable: false
          },
          {
            text: 'ДРФО',
            value: 'drfo',
            sortable: false
          },
          {
            text: 'Действителен до',
            value: 'valid_to',
            sortable: false
          },
          {
            text: 'Действия',
            value: 'name',
            sortable: false
          }
        ]
      }
    },
    methods: {
      toBase64: function (u8) {
        return btoa(String.fromCharCode.apply(null, u8))
      },
      async processFile(event) {
        this.add_dialog.form.file = this.$refs.pkey.$refs.input.files[0]
      },
      clearLocalStorage () {
        Object.keys(localStorage).filter(k => k.includes('key_')).map(k => localStorage.removeItem(k))
        alert('Локальное хранилище с ЭЦП очищено')
      },
      confirmDelete(item) {
        this.del_dialog.item = item
        this.del_dialog.show = true
      },
      deleteItem() {
        this.$store
          .dispatch('delCertificate', this.del_dialog.item.serial)
          .then(() => this.$store.dispatch('getCertificateList'))
          .then(() => this.del_dialog.show = false)
      },
      async submit_add () {

        this.add_dialog.form.alert = false

        this.$v.$touch()

        if (this.$v.$invalid)
          return

        this.add_dialog.form.loading = true

        let readedFile = new Uint8Array(await readFileFromComputer(this.add_dialog.form.file))

        let keys = []

        if (this.add_dialog.form.file.name.indexOf('.jks') !== -1) {
          let aliases = await enumJKSPrivateKeys(readedFile, this.eusign)
          for (let i = 0; i < aliases.length; i++) {
            let endUserInfo = await getJKSPrivateKey(readedFile, aliases[i], this.eusign)
            keys.push(endUserInfo.privateKey)
          }
        } else {
          keys.push(readedFile)
        }

        for (let i = 0; i < keys.length; i++) {
          let cert = await readPrivateKey(keys[i], this.add_dialog.form.password,
            this.add_dialog.form.issuer, this.eusign)

          if (cert.errorCode) {
            this.add_dialog.form.loading = false
            this.add_dialog.form.alert = true
            this.add_dialog.form.alert_error = cert.message
            return
          }

          let fd = new FormData()

          fd.append('issuer_index', this.cas.indexOf(this.add_dialog.form.issuer))
          fd.append('organization', cert.subjOrg)
          fd.append('name', cert.subjCN)
          fd.append('edrpou', cert.subjEDRPOUCode)
          fd.append('drfo', cert.subjDRFOCode)
          fd.append('serial', cert.serial)
          fd.append('title', cert.subjTitle)

          let toSign = [
            this.cas.indexOf(this.add_dialog.form.issuer),
            cert.subjOrg,
            cert.subjCN,
            cert.subjEDRPOUCode,
            cert.subjDRFOCode,
            cert.serial
          ]

          let external_sign = await signFile(new Blob([toSign.join(',')]), 1, true, true, this.eusign)

          if (external_sign.errorCode) {
            this.add_dialog.form.loading = false
            this.add_dialog.form.alert = true
            this.add_dialog.form.alert_error = `Ошибка: ${external_sign.message} (${external_sign.errorCode})`
            return
          }

          fd.append('sign', new Blob([external_sign.sign]))

          if (this.add_dialog.form.save_key) {
            localStorage.setItem('key_'+cert.serial, JSON.stringify({
              pkey: this.toBase64(keys[i]),
              dtime: moment().format('DD-MM-Y')
            }))
          }

          this.$store.dispatch('addCertificate', fd)
            .then(() => this.$nextTick(() => { this.$v.$reset() }))
            .then(() => this.$store.dispatch('getCertificateList'))
        }

        this.closeDialog()
        this.add_dialog.form.loading = false

      },
      reset () {
        this.add_dialog.form.alert = false
        this.$refs.add_form.reset()
        this.$v.add_dialog.form.$reset()
      },
      closeDialog () {
        this.reset()
        this.add_dialog.show = false
      }
    },

    computed: {
      ...mapState(['certificates', 'cas', 'eusign', 'eusigncp']),
      pkeyErrors () {
        let errors = []
        if (!this.$v.add_dialog.form.pkey.$dirty) return errors
        !this.$v.add_dialog.form.pkey.required && errors.push('Не выбран файл с ЭЦП.')
        return errors
      },
      issuerErrors () {
        let errors = []
        if (!this.$v.add_dialog.form.issuer.$dirty) return errors
        !this.$v.add_dialog.form.issuer.required && errors.push('Обязательное поле.')
        return errors
      },
      passwordErrors () {
        let errors = []
        if (!this.$v.add_dialog.form.password.$dirty) return errors
        !this.$v.add_dialog.form.password.required && errors.push('Обязательное поле.')
        return errors
      }
    },
    created () {
      this.$store.dispatch('getCertificateList')
    }
  }
</script>
